class PrivilagedButton extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    // if (button) button.addEventListener("click", this.privilegeBuy.bind(this));
    if (button) button.addEventListener("click", this.weekOffer.bind(this));
    
  }

// Regular Privilage Buy
  async privilegeBuy(event) {
    event.preventDefault();
    try {
      const varinat_id = parseInt(event.target.getAttribute("variantid"));
      const sku = parseInt(event.target.getAttribute("sku"));
      const inventoryStatus = await this.InventoryStatus(sku, warehouseId);
      const api_qyt = inventoryStatus?.quantity - 1;

      if (api_qyt > 0) {
        await $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            quantity: 1,
            id: varinat_id,
          },
          dataType: "json",
        });
        CartJS.getCart();
      } else if (api_qyt < 0) {
        await $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: {
            updates: {
              [varinat_id]: 1,
            },
          },
          dataType: "json",
        });
        CartJS.getCart();
      }
    } catch (error) {
      console.error("Error handling cart action:", error);
    }
  }

// Week47 or week2 offer
  async weekOffer(event) {
    event.preventDefault();
    try {
      const varinat_id = parseInt(event.target.getAttribute("variantid"));
      const sku = parseInt(event.target.getAttribute("sku"));
      const inventoryStatus = await this.InventoryStatus(sku, warehouseId);
      console.log('inventoryStatus',inventoryStatus);
      const api_qyt = inventoryStatus?.quantity - 1;

      if (api_qyt > 0) {
        await $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            quantity: 1,
            id: varinat_id,
          },
          dataType: "json",
        });
        CartJS.getCart();
      } else if (api_qyt < 0) {
        await $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: {
            updates: {
              [varinat_id]: 1,
            },
          },
          dataType: "json",
        });
        CartJS.getCart();
      }
    } catch (error) {
      console.error("Error handling cart action:", error);
    }
  }

  async InventoryStatus(skuId, warehouseId) {
    var inventory_status;
    try {
      const myHeaders = {
        "Content-Type": "application/json",
      };
      const raw = JSON.stringify({
        sku: skuId,
        warehouse: warehouseId,
      });
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        "https://tupperware.enscommerce.in/tupperwear/checkinventory",
        requestOptions
      );
      const result = await response.json();
      if (result.success) {
        inventory_status =
          result.availableQty > 0
            ? { status: true, quantity: result.availableQty }
            : { status: false, quantity: 0 };
      }
    } catch (error) {
      console.log(error.message);
      return { status: false, quantity: 0 };
    }
    return inventory_status;
  }
}

customElements.define("privilaged-buttton", PrivilagedButton);
